import { FaLock, FaCrown, FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const LockedCard = ({ children, requiredLevel, planLevel }) => {
  const isLocked = planLevel <= requiredLevel;

  const Navigate = useNavigate();

  return (
    <div className={`locked-card-wrapper position-relative ${isLocked ? 'locked' : ''}`}>
      {children}

      {isLocked && (
        <>
          {/* Lock icon visible before hover */}
          <div className='card-lock-icon'>
            <FaLock />
          </div>

          {/* Overlay content */}
          <div className='locked-overlay'>
            <div className='locked-content'>
              <div className='lock-icon-wrapper mb-3'>
                <FaCrown className='crown-icon' />
              </div>

              <h5 className='locked-title mb-2'>Upgrade your plan to use this feature</h5>
              <p className='locked-description mb-3'>Unlock essential analytics by subscribing to next plan</p>

              <button className='btn-generatedlead d-flex align-items-center justify-content-center gap-2 m-auto' onClick={() => Navigate('/pricing')}>
                <span>Upgrade Now</span>
                <FaArrowRight className='arrow-icon' />
              </button>

              {/* <div className='features-list mt-3'>
                <div className='feature-item'>
                  <span className='checkmark'>✓</span>
                  <span>Advanced Analytics</span>
                </div>
                <div className='feature-item'>
                  <span className='checkmark'>✓</span>
                  <span>Real-time Insights</span>
                </div>
                <div className='feature-item'>
                  <span className='checkmark'>✓</span>
                  <span>Custom Reports</span>
                </div>
              </div> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LockedCard;
